import { useAuth } from '../contexts/AuthContext.js';

// Must match webApplicationInfo.id in manifest.json. The redirect must be one the app
// registration lists: without it Entra picks a registered redirect on its own, which is
// how the old registration sent Teams reviewers to localhost.
const AZURE_AD_CLIENT_ID = '2b09a8bd-ce11-4fda-a6b7-0a54e70ec44f';
const CONSENT_REDIRECT_URI = 'https://app.annoteer.app/auth-end';
const ADMIN_CONSENT_URL =
  'https://login.microsoftonline.com/common/adminconsent' +
  `?client_id=${AZURE_AD_CLIENT_ID}` +
  `&redirect_uri=${encodeURIComponent(CONSENT_REDIRECT_URI)}`;

/**
 * Shared auth status banner — renders nothing when authenticated,
 * otherwise shows initializing/error/consent_required state with
 * Retry and Grant consent actions. Mount this at the top of every
 * top-level view (SidePanel, MeetingStage, etc.).
 */
export function AuthStatusBanner() {
  const { status, error, retryAuth } = useAuth();

  if (status === 'authenticated') return null;

  const isErrorLike = status === 'error' || status === 'consent_required';

  return (
    <div
      style={{
        padding: '8px 12px',
        margin: '8px',
        borderRadius: 6,
        background: isErrorLike ? '#4b1d1d' : '#1f2937',
        color: isErrorLike ? '#fca5a5' : '#d1d5db',
        fontSize: 12,
        fontFamily: 'monospace',
        wordBreak: 'break-word',
      }}
    >
      <div>
        Auth: {status}
        {error ? ` — ${error}` : ''}
      </div>
      {isErrorLike && (
        <div style={{ marginTop: 8, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            onClick={retryAuth}
            style={{
              background: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '4px 10px',
              borderRadius: 4,
              fontSize: 11,
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
          {status === 'consent_required' && (
            <a
              href={ADMIN_CONSENT_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: '#7c3aed',
                color: 'white',
                textDecoration: 'none',
                padding: '4px 10px',
                borderRadius: 4,
                fontSize: 11,
              }}
            >
              Grant consent
            </a>
          )}
        </div>
      )}
    </div>
  );
}
